import YoutubeTextAndAssetComponent from "./youtube-text-and-asset-component";
import YoutubeTextAndAssetConfig from "./youtube-text-and-asset-config";
import YoutubeTextAndAssetAdvancedConfig from "./youtube-text-and-asset-advanced-config";

export default {
  YoutubeTextAndAssetComponent,
  YoutubeTextAndAssetConfig,
  YoutubeTextAndAssetAdvancedConfig
};
